import { useState } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import Select from './Select'
import ButtonUpload from './ButtonUpload'
import { useGetCampionatiQuery } from '../hooks/api-slice'

const DialogUploadCalendari = ({ open, handleClose }) => {
  const { data: campionati } = useGetCampionatiQuery()

  const campionatiAperti = campionati?.filter(c => !c.campionatoChiuso)

  const [uploadCampionato, setUploadCampionato] = useState()

  return (
    <Dialog open={open} handleClose={handleClose} title='Carica calendari'>
      <Grid container spacing={3} paddingTop={1} sx={{ width: '100%' }}>
        <Grid size={12}>
          <Select
            id='campionato'
            label='Campionato'
            value={uploadCampionato}
            options={campionatiAperti?.map(c => c.codice)}
            optionLabels={campionatiAperti?.map(c => c.nome)}
            onChange={setUploadCampionato}
          />
        </Grid>
        <Grid size={12}>
          Se in piattaforma ci sono già partite di categorie/gironi presenti
          anche nel file che si sta caricando, le partite in piattaforma
          verranno eliminate e sostituite da quelle del file.
          <br />
          <br />
          Esempio: se nel file ci sono delle partite del girone 4 di U12,
          verranno eliminate dalla piattaforma tutte le partite del girone 4 di
          U12 e sostituite da quelle del file.
          <br />
          <br />
          Tuttavia, se nel file ci sono partite con numeri gara già presenti in
          piattaforma per il campionato scelto, tali partite e tutte quelle del
          relativo girone verranno saltate.
          <br />
          <br />
          <b>
            Alla fine, leggere il LOG per verificare il corretto caricamento di
            tutte le partite.
          </b>
          <br />
        </Grid>
        <Grid size={12}>
          <center>
            <ButtonUpload
              buttonText='Carica CSV'
              algorithm='05_UpdateCalendari'
              fileName='Input'
              runScript
              uploadCampionato={uploadCampionato}
            />
          </center>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default DialogUploadCalendari
